import clsx from 'clsx';
import React, { useCallback } from 'react';

import { useInbox } from '@/src/components/project/Inbox2/store/inbox.store';
import { EmailEntryToggleableListItem } from '@/src/components/project/Inbox2/types';
import { DEFAULT_DATE_FORMAT } from '@/src/config';
import { useToggle } from '@/src/hooks/useToggle';

import { useDeletedStaleEntrySubscriber } from '../../../../../useDeletedStaleEntrySubscriber';
import EmailEntryExpanded from '../EmailEntryExpanded/EmailEntryExpanded';
import EmailEntrySummary from '../EmailEntrySummary/EmailEntrySummary';

export const DATE_FORMAT = `${DEFAULT_DATE_FORMAT} h:m A`;

type EmailEntryProps = {
  emailEntryToggleableListItem: EmailEntryToggleableListItem;
  isLastItem?: boolean;
};

const EmailEntry = ({ emailEntryToggleableListItem, isLastItem = false }: EmailEntryProps) => {
  const [isExpanded, toggleIsExpanded] = useToggle(emailEntryToggleableListItem.isExpanded);
  const { deletedEmailEntries } = useInbox();
  const deletedStaleEntrySubscriber = useDeletedStaleEntrySubscriber({
    shouldWatchDeletedStaleEntryClicks:
      deletedEmailEntries &&
      deletedEmailEntries[emailEntryToggleableListItem.emailEntryListItem.id],
  });

  const handleClick = useCallback(() => {
    if (!isLastItem) {
      toggleIsExpanded();
    }

    // Only use this if we plan to reupdate the source list and rerender it from toggling different tabs
    // But currently, we just hide the whole list to avoid rerendering
    // queryClient.setQueriesData(
    //   [...emailEntriesKeys.list, emailEntryItem.threadId],
    //   (prev: any) => {
    //     return {
    //       ...prev,
    //       pages: prev.pages.map((page) => {
    //         return {
    //           ...page,
    //           data: {
    //             ...page.data,
    //             result: page.data.result.map((rawEmailSummaryItem) => {
    //               if (rawEmailSummaryItem.inbox.emailId === emailEntryItem.emailId) {
    //                 return {
    //                   ...rawEmailSummaryItem,
    //                   isExpanded: !rawEmailSummaryItem.isExpanded,
    //                 };
    //               }

    //               return rawEmailSummaryItem;
    //             }),
    //           },
    //         };
    //       }),
    //     };
    //   }
    // );
  }, [isLastItem, toggleIsExpanded]);

  const showExpanded = isLastItem ? true : isExpanded;

  return (
    <React.Fragment>
      <div
        className="ee"
        role="button"
        tabIndex={0}
        onClick={deletedStaleEntrySubscriber?.onSyncDeletedStaleEntry}
        onKeyDown={deletedStaleEntrySubscriber?.onSyncDeletedStaleEntry}
      >
        <div
          className={clsx(
            'ee_body',
            deletedStaleEntrySubscriber?.shouldWatchDeletedStaleEntryClicks &&
              'tw-pointer-events-none'
          )}
        >
          {!showExpanded ? (
            <EmailEntrySummary
              key={`ees_${emailEntryToggleableListItem.emailEntryListItem.id}`}
              emailEntryListItem={emailEntryToggleableListItem.emailEntryListItem}
              onClick={handleClick}
            />
          ) : (
            <EmailEntryExpanded
              key={`ees_${emailEntryToggleableListItem.emailEntryListItem.id}`}
              emailEntryListItem={emailEntryToggleableListItem.emailEntryListItem}
              isLastItem={isLastItem}
              onClick={handleClick}
            />
          )}
        </div>
      </div>
      {deletedStaleEntrySubscriber && <deletedStaleEntrySubscriber.ConfirmRefreshDeletedModal />}
    </React.Fragment>
  );
};

export default EmailEntry;
